<template>
    <fragment>
        <b-table :fields="fields" :items="items" :busy="tableBusy" :current-page="currentPage" hover no-border-collapse
            sort-by="" :sort-desc="true" stacked="md" show-empty>
            <template #empty>
                <span>Não foram encontrados dados.</span>
            </template>
            <template #emptyfiltered>
                <span>Não foram encontrados dados.</span>
            </template>
            <template #table-busy>
                <div class="text-center text-dark">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong class="loading-text">Carregando...</strong>
                </div>
            </template>
            <template v-slot:cell(detalhes)="row">
                <b-link class="text-dark" @click="row.toggleDetails">
                    <font-awesome-icon :icon="row.detailsShowing ? 'chevron-up' : 'chevron-down'" />
                </b-link>
            </template>
            <template #row-details="row">
                <editar-itens-vencedores-lote-licitacao :key="keyTabelaItens" :idLote="row.item.IdLoteLicitacao"
                    @loteAtualizado="atualizarLote" />
            </template>
            <template #cell(IsLotePreenchido)="data">
                <font-awesome-icon :icon="data.item.IsLotePreenchido ? 'check' : 'cancel'"
                    :class="data.item.IsLotePreenchido ? 'text-success' : 'text-warning'" />
            </template>
            <template #cell(FlFracassado)="data">
                <span>{{ data.item.FlFracassado }}</span>
                <seletor-fracassado :loteLicitacao="data.item"
                    @sitFracassoAtualizada="e => atualizarVencedor(data.item, e)" />
            </template>
            <template #cell(NmParticipante)="data">
                <span v-if="isHmlParcial && !data.item.modoEdicao">
                    {{ data.item.IdParticipanteLicitacaoNavigation ?
                        data.item.IdParticipanteLicitacaoNavigation.NmParticipante : '' }}
                    <b-button size="sm" variant="outline-secondary" class="ml-1 extra-small"
                        @click="ativarModoEdicaoVencedorLote(data.item)">
                        <font-awesome-icon v-if="data.item.IdParticipanteLicitacaoNavigation" icon="refresh" />
                        <fragment v-else>
                            <font-awesome-icon icon="trophy" class="mr-1" />
                            Escolher vencedor
                        </fragment>
                    </b-button>
                </span>
                <multiselect v-if="isHmlParcial && data.item.modoEdicao"
                    v-model="data.item.IdParticipanteLicitacaoNavigation" close-on-select searchable :show-labels="false"
                    label="NmParticipante" deselect-label="" :allow-empty="true" placeholder="Selecione um"
                    track-by="IdParticipanteLicitacao" :options="participantes" class="w-100" :disabled="data.item.loading">
                    <template slot="noOptions">
                        <small><i>Nenhum participante cadastrado</i></small>
                    </template>
                    <template slot="noResult">
                        <i>Nenhum participante encontrado</i>
                    </template>
                </multiselect>
                <seletor-vencedor-lote v-if="!isHmlParcial" :lote="data.item" :participantes="participantes"
                    @modoEdicao="ativarModoEdicaoVencedorLote(data.item)"
                    @cancelarEdicao="desativarModoEdicaoVencedorLote(data.item)"
                    @vencedorFoiAlterado="lvl => atualizarVencedor(data.item, lvl)">
                </seletor-vencedor-lote>
            </template>
            <template #cell(DtHomologacaoLote)="data">
                <b-form-datepicker v-if="data.item.modoEdicao && isHmlParcial" v-model="data.item.DtHomologacaoLote"
                    v-bind="datePickerProps" />
                <span v-else>{{ data.item.DtHomologacaoLote ? data.item.DtHomologacaoLote.toLocaleDateString() : ''
                }}</span>
            </template>
            <template #cell(acoes)="data">
                <b-button v-if="data.item.modoEdicao" size="sm" @click="salvarParticipanteLoteHmlParcial(data.item)"
                    variant="success" :disabled="data.item.loading" class="mr-1">
                    <b-spinner v-if="data.item.loading" small class="align-middle"></b-spinner>
                    <span v-else>
                        <font-awesome-icon icon="save" />
                        Salvar
                    </span>
                </b-button>
                <b-button v-if="data.item.modoEdicao" size="sm" @click="desativarModoEdicaoVencedorLote(data.item)"
                    variant="danger" :disabled="data.item.loading">
                    <font-awesome-icon icon="ban" />
                </b-button>
            </template>
        </b-table>
        <table-pagination v-if="totalRows > 10" :total-rows="totalRows" :per-page="10" @pageChange="pageChange" />
    </fragment>
</template>

<script lang="ts">
import TablePagination from '@/components/atos-pessoal/TablePagination.vue'
import { eventBus } from '@/main'
import ldiService from '@/services/licitacoes/ldiService'
import { DatePickerDefaultProps } from '@/types/form-default-props'
import { acoesEdicaoLoteDinamica, detalhes, fieldsVencedoresLicitacaoLote } from '@/types/licitacoes/ldi/fields-lote-licitacao'
import { Licitacao } from '@/types/licitacoes/ldi/licitacao'
import { LicitacaoVencedorLote } from '@/types/licitacoes/ldi/licitacao-vencedor-lote'
import { ParticipanteLicitacao } from '@/types/licitacoes/ldi/participante-licitacao'
import { LoteLicitacaoParcial } from '@/types/licitacoes/ldi/retornos/lote-licitacao-parcial'
import { TableField } from '@/types/table-field'
import { UtilsTS } from '@/utilsts'
import { PropType } from "vue"
import { mixins } from 'vue-class-component'
import Multiselect from "vue-multiselect"
import { Component, Vue } from 'vue-property-decorator'
import EditarItensVencedoresLoteLicitacao from './EditarItensVencedoresLoteLicitacao.vue'
import SeletorFracassado from './SeletorFracassado.vue'
import SeletorVencedorLote from './SeletorVencedorLote.vue'
import { PortalError } from '@/types/portal-error'

const CompProps = Vue.extend({
    name: 'EditarVencedoresLoteTable',
    components: { EditarItensVencedoresLoteLicitacao, Multiselect, SeletorFracassado, SeletorVencedorLote, TablePagination },
    props: {
        licitacao: {
            type: Object as PropType<Licitacao>,
            required: true
        }
    }
})

@Component
export default class EditarVencedoresLoteTable extends mixins(UtilsTS, CompProps) {
    fields: TableField[] = [detalhes, ...fieldsVencedoresLicitacaoLote]
    items: LicitacaoVencedorLote[] = []
    participantes: ParticipanteLicitacao[] = []
    fieldColunaAcoes: TableField = acoesEdicaoLoteDinamica
    datePickerProps = DatePickerDefaultProps

    //table-related
    currentPage = 1
    pageSize = 10
    totalRows = 0
    tableBusy = false

    keyTabelaItens = 0

    get isHmlParcial(): boolean {
        return this.licitacao.FlHomologParcial === 'Sim' || this.licitacao.FlHomologParcial === 'S'
    }

    // Carregamento de dados
    async mounted() {
        await this.buscarParticipantes()
        await this.loadData()
    }
    async pageChange(value) {
        this.currentPage = value;
        await this.loadData();
    }
    async loadData(): Promise<void> {
        try {
            this.tableBusy = true
            const response = await ldiService.buscarVencedores(this.licitacao.IdLicitacao, this.currentPage, this.pageSize)
            // console.log('vencedores do lote: ', response)
            this.items = response.vencedores
            this.totalRows = response.totalRows
        } catch (e) {
            console.error(e)
            this.$toast.error('Falha ao buscar vencedores. ' + e)
        } finally {
            this.tableBusy = false
        }
    }
    async buscarParticipantes(): Promise<void> {
        try {
            this.tableBusy = true
            const response = await ldiService.buscarParticipantes(this.licitacao.IdLicitacao)
            // console.log('peguei os participantes do lote', response)
            if (response) {
                this.participantes = response.participantes.map(p => {
                    const item = Object.assign(new ParticipanteLicitacao(), p)
                    return item
                })
            } else {
                this.$toast.error('Erro ao consultar os participantes da licitação.');
            }
        } catch (e) {
            console.error(e)
            this.$toast.error('Falha ao buscar participantes. ' + e)
        } finally {
            this.tableBusy = false
        }
    }
    // Carregamento de dados

    // Edição de um lote
    async ativarModoEdicaoVencedorLote(item: LicitacaoVencedorLote): Promise<void> {
        const meuLote = this.items.find(lo => lo.IdLoteLicitacao === item.IdLoteLicitacao)
        if (meuLote) {
            this.fecharTodasRows()
            meuLote.modoEdicao = true
            meuLote._rowVariant = 'active'
            meuLote._showDetails = true
            if (this.isHmlParcial) this.fields.push(this.fieldColunaAcoes)
        }
    }
    async desativarModoEdicaoVencedorLote(item: LicitacaoVencedorLote): Promise<void> {
        const meuLote = this.items.find(lo => lo.IdLoteLicitacao === item.IdLoteLicitacao)
        if (meuLote) {
            meuLote.modoEdicao = false
            meuLote._rowVariant = ''
            this.fields = this.fields.filter(f => f.key !== this.fieldColunaAcoes.key)
        }
    }
    async atualizarVencedor(lvl: LicitacaoVencedorLote, lvlAtualizado: LicitacaoVencedorLote): Promise<void> {
        try {
            const novoLvl = Object.assign(lvl, lvlAtualizado)
            if (lvlAtualizado.FlFracassado === 'Sim' && !lvlAtualizado.DtHomologacaoLote) delete novoLvl.DtHomologacaoLote
            if (lvlAtualizado.FlFracassado === 'Sim' && !lvlAtualizado.VlTotalLicitado) novoLvl.VlTotalLicitado = 0
            this.trocarLvl(lvl, novoLvl)
            this.keyTabelaItens++
            this.$toast.success(`O lote ${novoLvl.DeLote} foi atualizado!`)
            eventBus.$emit('atualizar-status-licitacao')
            eventBus.$emit('atualizar-homologacao-licitacao')
        } catch (e: any) {
            this.tratarError(e)
        }
    }
    atualizarLote(novoLote: LoteLicitacaoParcial): void {
        const loteAtual = this.items.find(lvl => lvl.IdLoteLicitacao === novoLote.IdLoteLicitacao)
        if (loteAtual) {
            this.trocarLvl(loteAtual, Object.assign(loteAtual, novoLote))
            eventBus.$emit('atualizar-status-licitacao')
        } else {
            this.$toast.error('Falha ao atualizar o lote referente ao item recém atualizado. Por favor atualize a página')
        }
    }
    async salvarParticipanteLoteHmlParcial(itemAtual: LicitacaoVencedorLote): Promise<void> {
        //console.log(itemAtual)
        const meuLote = this.items.find(lo => lo.IdLoteLicitacao === itemAtual.IdLoteLicitacao)
        try {
            if (!meuLote) throw new PortalError('Lote não encontrado, por favor atualize a página.')

            //ativar loading
            meuLote.loading = true
            //chamar ldiService.alterarVencedorLoteLicitacao com param extra
            const retorno = await ldiService.alterarVencedorLoteLicitacao(itemAtual.IdLoteLicitacao, itemAtual.IdParticipanteLicitacaoNavigation.IdParticipanteLicitacao, itemAtual.DtHomologacaoLote)
            //criar nova instância de LVL com o retorno do service
            const lvl = new LicitacaoVencedorLote()
            lvl.NmParticipante = retorno.IdParticipanteLicitacaoNavigation.NmParticipante
            lvl.participanteVencedor = retorno.IdParticipanteLicitacaoNavigation.IdParticipanteLicitacao
            lvl.IdParticipanteLicitacaoNavigation = Object.assign(new ParticipanteLicitacao(), retorno.IdParticipanteLicitacaoNavigation)
            lvl.modoEdicao = false
            lvl._rowVariant = ''
            lvl.loading = false
            //chamar o this.atualizarVencedor com o novo LVL
            this.atualizarVencedor(meuLote, lvl)
        } catch (e: any) {
            this.tratarError(e)
        } finally {
            if (meuLote) meuLote.loading = false
        }
    }
    // edição de um lote

    // operação da datatable
    trocarLvl(antigo, novo) {
        const index = this.items.indexOf(antigo)
        this.items.splice(index, 1, novo)
        this.$emit('input', this.items);
    }
    fecharTodasRows() {
        this.items.forEach(item => item._showDetails = false)
        this.$emit('input', this.items);
    }
    // fim operação da datatable

    // atualizar datas de homologação quando a data da licitação é mudada
    async atualizarDatasHomologacao(novaData: Date) {
        for await (const lote of this.items) {
            lote.DtHomologacaoLote = novaData
        }
        this.$emit('input', this.items);
    }

    created() {
        eventBus.$on('atualizar-datas-homologacao', this.atualizarDatasHomologacao)
    }
    destroyed() {
        eventBus.$off('atualizar-datas-homologacao', this.atualizarDatasHomologacao)
    }
    // fim atualizar datas de homologação quando a data da licitação é mudada
}
</script>